import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHashtag, faClock, faLock, faTruckFast } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const STEPS = [
    {
        id: 1,
        title: "Start the Chat",
        desc: "Click the WhatsApp icon to begin the conversation.",
        icon: <FontAwesomeIcon icon={faWhatsapp} />,
    },
    {
        id: 2,
        title: "Share Product ID",
        desc: "Send the unique ID found on the product card in Collection page.",
        icon: <FontAwesomeIcon icon={faHashtag} />,
    },
    {
        id: 3,
        title: "Wait for Response",
        desc: "We typically confirm availability within 1 hour.",
        icon: <FontAwesomeIcon icon={faClock} />,
    },
    {
        id: 4,
        title: "Secure Payment",
        desc: "Complete the purchase via our secure payment link.",
        icon: <FontAwesomeIcon icon={faLock} />,
    },
    {
        id: 5,
        title: "Fast Delivery",
        desc: "Receive your handcrafted order in just 2 days.",
        icon: <FontAwesomeIcon icon={faTruckFast} />,
    },
];

export default function HowToOrder() {
    const observerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("animate");
                    }
                });
            },
            { threshold: 0.2 }
        );

        const cards = document.querySelectorAll(".hto-card");
        cards.forEach((card) => observer.observe(card));

        return () => observer.disconnect();
    }, []);

    return (
        <section className="hto-section">
            {/* Random Floating Leaves (Decreased count & Random positions) */}
            <img src="images/leaf.webp" className="hto-leaf" style={{ top: '10%', left: '5%', width: '35px', animationDelay: '0s' }} alt="" />
            <img src="images/leaf.webp" className="hto-leaf" style={{ top: '60%', right: '8%', width: '45px', animationDelay: '2s' }} alt="" />
            <img src="images/leaf.webp" className="hto-leaf" style={{ bottom: '15%', left: '12%', width: '25px', animationDelay: '4s' }} alt="" />

            <div className="hto-container">
                <div className="hto-header">
                    <span className="hto-subtitle">Simple & Seamless</span>
                    <h2 className="hto-title">How to Order</h2>
                </div>

                <div className="hto-timeline">
                    {/* The connecting line backdrop */}
                    <div className="hto-line"></div>

                    {STEPS.map((step, index) => (
                        <div className="hto-card" key={step.id} style={{ "--delay": `${index * 0.2}s` }}>
                            <div className="hto-icon-box">
                                {step.icon}
                                <div className="hto-step-number">{step.id}</div>
                            </div>
                            <h3 className="hto-card-title">{step.title}</h3>
                            <p className="hto-card-desc">{step.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}